module.exports = __webpack_public_path__ + "static/media/Editar.56009314.svg";